import { defineMessages } from 'react-intl';

export default defineMessages({
    tokenExpiredmessage: {
        defaultMessage: 'Signup link expired',
        description: 'Message shown when a signup token has expired',
        id: 'cv.complete.sign.expired.token.screen.token.expired.message',
    },
    resendSignUpLinkButton: {
        defaultMessage: 'Resend signup link',
        description:
            'Button label to resend a new complete signup link on screen shown when a signup token has expired',
        id: 'cv.complete.sign.expired.token.screen.resend.link.button',
    },
});
